import React, {useContext} from "react";
import {useProjectId} from "../ProjectName";
import {TableContext} from "../../../../misc/scroller/Table";
import {useNavigate} from "react-router-dom";
import {buildFilterLink} from "../../../../misc/scroller/Filter";
import {logisticsTableName} from "../logistics/Logistics";
import {GlazingItem} from "../../../../api/Glazing";
import {useIsQuote} from "../../quote/QuoteContainer";
import {removeRowOption, RowOptions} from "../../../logistics/purchasing/RowOptions";

// Row menu for the Glazing workspace. A generated row is the elevation's to remove, so only a
// one-off offers Archive.
export function RowActions(props: {
    row: GlazingItem;
}) {
    const project = useProjectId();
    const isQuote = useIsQuote();
    const nav = useNavigate();
    const tbl = useContext(TableContext);

    // a one-off is listed under its own label in logistics (see glazing.nonOpeningLabel)
    const logisticsName = props.row.openingName || `Glazing #${props.row.id}`;

    return <RowOptions<GlazingItem> draggable options={[
        !isQuote && {
            name: "View in Logistics",
            onClick: (input) => {
                input.onClose();
                nav(`/project/${project}/shop-drawing/logistics/glazing?${buildFilterLink({
                    tableName: logisticsTableName(project, "glazing"),
                    filter: {
                        type: "eq",
                        search: {
                            openingName: logisticsName,
                        },
                    }
                })}`);
            },
        },
        !props.row.generated && Object.assign(removeRowOption(props.row, {
            refreshTables: [],
            confirm: true,
            onComplete: () => tbl.reload(false),
        }), {
            name: "Archive",
        }),
    ]} />
}
